<template>
    <div v-html="require(`../assets/${icon}.svg`)" class="svg-container"></div>
</template>

<script>
    export default {
        name: 'SvgIcon',
        props: {
            icon: {
                type: String,
                default: null
            },
        },
        mounted() {
            if (this.$el.firstElementChild.nodeName === 'svg') {
                const svgElement = this.$el.firstElementChild;
                svgElement.setAttribute('style', `display: block; width: 100%; height: 100%`);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .svg-container svg {
        display: block;
    }
</style>
